<script>
import { mapGetters } from 'vuex';
import FilterChip from './FilterChip.vue';

export default {
  name: 'ReportsFiltersAgents',
  components: { FilterChip },
  emits: ['agentsFilterSelection'],
  data() {
    return {
      selectedOptions: [],
    };
  },
  computed: {
    ...mapGetters({
      options: 'agents/getAgents',
    }),
  },
  mounted() {
    this.$store.dispatch('agents/get');
  },
  methods: {
    handleInput() {
      this.$emit('agentsFilterSelection', this.selectedOptions);
    },
  },
};
</script>

<template>
  <FilterChip
    v-model="selectedOptions"
    :options="options"
    multiple
    :placeholder="$t('CSAT_REPORTS.FILTERS.AGENTS.PLACEHOLDER')"
    icon="i-lucide-users"
    @update:model-value="handleInput"
  />
</template>
